import api from "./api";

const activityService = {
  async getMyRecentActivities(params = {}) {
    const response = await api.get("/activities/me", { params });
    return response.data?.data || [];
  },
};

export default activityService;

